import type { IncidentListRow } from '@/features/shared/incidentListRow';
import { IncidentListItemComponent } from './IncidentListItemComponent';

export type IncidentListComponentProps = {
  incidents: readonly IncidentListRow[];
};

export function IncidentListComponent({ incidents }: IncidentListComponentProps) {
  return (
    <div className="incident-list-component">
      {incidents.map((incident) => (
        <IncidentListItemComponent key={incident.id} item={incident} />
      ))}
    </div>
  );
}
